import createMemo from 'modules/core/hooks/createMemo'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import ChangesCollection from 'modules/bookkeepers/store/collections/changes'
import { Files } from 'modules/bookkeepers/store/collections/files'
import IncidenceDetail from 'modules/bookkeepers/store/models/IncidenceDetail'

const incidenceFilesCollectionMemo = createMemo(() => new Files([]))
const incidenceDetailMemo = createMemo((incidenceId) => new IncidenceDetail({ incidenceId }))

const incidenceChangesCollectionMemo = createMemo((incidenceId) => {
  return new ChangesCollection([], incidenceId)
})

const useFetchIncidenceDetails = (incidenceId?: string) => {
  const incidenceDetailModel = incidenceDetailMemo(incidenceId)
  const incidenceChangesCollection = incidenceChangesCollectionMemo(incidenceId)
  const incidenceFilesCollection = incidenceFilesCollectionMemo()
  const isBookkeeperView = useBookkeeperView()

  const { loading } = useAsyncData(() => {
    if (!incidenceId) return Promise.resolve()

    const params = {
      data: {
        bookkeeper_view: isBookkeeperView,
      },
    }

    return Promise.all([
      incidenceFilesCollection.fetch({
        data: {
          ...params.data,
          incidence_id: incidenceId,
        },
      }),
      incidenceChangesCollection.fetch(params),
      incidenceDetailModel.fetch({
        ...params,
        path: `/bookkeepers_management/incidences/${incidenceId}/detail`,
      }),
    ])
  }, [incidenceId, isBookkeeperView])

  return {
    loading,
    incidenceDetailModel,
    incidenceChangesCollection,
    incidenceFilesCollection,
  }
}

export default useFetchIncidenceDetails
